var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStepsBackground2 = function SvgStepsBackground2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 673,
    height: 939,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#steps_background_2_svg__a)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#steps_background_2_svg__b)",
    d: "M160.418 598.519C180.692 243.228 915.923 89 915.923 89l709.487 509.519-569.99 504.981S137.556 999.183 160.418 598.519Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "steps_background_2_svg__b",
    x1: 892.697,
    x2: 892.697,
    y1: 1103.5,
    y2: 89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#885AFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664,
    stopColor: "#00193F"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "steps_background_2_svg__a",
    width: 1785.41,
    height: 1334.5,
    x: 0,
    y: -71,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_1364_1674",
    stdDeviation: 80
  })))));
};
export default SvgStepsBackground2;